module.exports = __webpack_public_path__ + "assets/75ec08ba75a2ba4ac09730f5bd1db83b.jpg";